import styled from 'styled-components';
import PageTitle from './PageTitle';
import { appTheme } from '../../theme';

export default styled(PageTitle)`
  margin: 0 ${appTheme.spacing.small} 0 0;
`;



// WEBPACK FOOTER //
// ./src/modules/common/HeaderTitle.js